import { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "@/components/layout/Sidebar";
import TopBar from "@/components/layout/TopBar";
import { Sheet, SheetContent } from "@/components/ui/sheet";

export default function AppLayout() {
    const [mobileOpen, setMobileOpen] = useState(false);

    return (
        <div className="flex h-screen w-full bg-background text-foreground overflow-hidden">
            {/* Desktop sidebar */}
            <div className="hidden lg:block h-full">
                <Sidebar />
            </div>

            {/* Mobile sidebar */}
            <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
                <SheetContent side="left" className="p-0 w-[260px] border-none bg-sidebar">
                    <Sidebar onNavigate={() => setMobileOpen(false)} />
                </SheetContent>
            </Sheet>

            {/* Main */}
            <div className="flex min-w-0 flex-1 flex-col">
                <TopBar onOpenSidebar={() => setMobileOpen(true)} />
                <main className="flex-1 overflow-y-auto">
                    <div className="mx-auto max-w-[1600px] px-4 md:px-6 lg:px-8 py-6 md:py-8">
                        <Outlet />
                    </div>
                </main>
            </div>
        </div>
    );
}
